import { MARKETPLACE_TAGLINE } from '@lighthouse/shared';

const VALUES = [
  {
    title: 'Licensed & verified',
    body: 'Every therapist is checked against CASSON, NACP, and other recognised licensing bodies before joining.',
  },
  {
    title: 'Built for Nigeria',
    body: 'Sessions in naira, local crisis resources, and support in English, Yoruba, Igbo, and Hausa.',
  },
  {
    title: 'Private by design',
    body: 'NDPA-compliant data handling, encrypted clinical notes, and you control what you share.',
  },
] as const;

export function AboutSection() {
  return (
    <div className="landing-about-grid">
      <div>
        <p className="landing-section-kicker">About Mylighthouse</p>
        <h2 className="landing-section-title">Mental health care that meets you where you are</h2>
        <p className="mt-4 text-sm leading-relaxed text-gray-600 sm:text-base">
          Mylighthouse is {MARKETPLACE_TAGLINE} — connecting people with licensed therapists for
          video, voice, and chat sessions. We make it simple to take a free assessment, find the
          right professional, and build ongoing care at your own pace.
        </p>
        <p className="mt-3 text-sm leading-relaxed text-gray-600 sm:text-base">
          Mylighthouse is built by StackMap Systems with a single goal: remove the friction between
          needing support and receiving quality, confidential care.
        </p>
      </div>
      <div className="space-y-3">
        {VALUES.map((item) => (
          <div key={item.title} className="card p-4 sm:p-5">
            <h3 className="text-sm font-bold text-gray-900">{item.title}</h3>
            <p className="mt-1.5 text-sm leading-relaxed text-gray-600">{item.body}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
